//= Functions & Modules
// Others
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

type Props = {
    title: string;
    onClose: () => void;
    className?: string;
    error?: boolean;
};

export class Dialog extends React.PureComponent<Props> {
    static defaultProps = {
        className: '',
    };

    render() {
        return (
            <div
                className={`flex flex-col rounded-2xl bg-surface overflow-hidden shadow-xl ${this.props.className}`}
                style={{ border: '1px solid rgba(255,255,255,0.08)' }}
            >
                <div
                    className={`flex items-center justify-between px-4 py-3 ${
                        this.props.error
                            ? 'bg-danger/10 border-b border-danger/20'
                            : 'bg-white/[0.03] border-b border-white/[0.08]'
                    }`}
                >
                    <span
                        className={`text-sm font-semibold ${this.props.error ? 'text-danger' : 'text-title'}`}
                    >
                        {this.props.title}
                    </span>
                    <button
                        type="button"
                        onClick={this.props.onClose}
                        className="text-unselected1 hover:text-title transition-colors cursor-pointer ml-4"
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </div>
                <div className="p-4">{this.props.children}</div>
            </div>
        );
    }
}
